import React from 'react'
import { connect } from 'react-redux'
import { OrganizationData } from '../types'

interface OrganizationSummaryOwnProps {
  showSettingsLabel?: boolean
}

interface OrganizationSummaryStateProps {
  organization: OrganizationData
}

type OrganizationSummaryProps = OrganizationSummaryOwnProps & OrganizationSummaryStateProps

const OrganizationSummary = ({ showSettingsLabel, organization }: OrganizationSummaryProps): JSX.Element => {
  return (
    <div className="row gy-3 mb-6 justify-content-between">
      <div className="col-md-9 col-auto">
        <h3 className="mb-2 text-1100">{organization?.name}</h3>
        {showSettingsLabel ? (
          <h5 className="text-700 fw-semi-bold">
            Global configurations for your organization. This should be configured before grants and works are created.
          </h5>
        ) : null}
      </div>
    </div>
  )
}

const mapStateToProps = (state: any): OrganizationSummaryStateProps => {
  return {
    organization: state.auth.organization,
  }
}

export default connect(mapStateToProps)(OrganizationSummary)
